module.exports = __webpack_public_path__ + "static/gnome_rock_male_DMG-4a452e86874fd0b3f54409315339f241.png";